<template>
  <!-- MAIN CONTENT - TOOLBOX -->
  <div class="main-content">
    <h1 v-translate>Toolbox</h1>
    <div class="main-content__toolbox">

      <tabs :key="'tabs_navigator'+tab_location" v-model="tab_location" :use_router="false" :links="tab_links"></tabs>

      <div v-if="tab_location == 'tutorials'">
        <videos :key="'videos'+tab_location" url="/api/navigator/toolbox/navigator-tutorials/" title="Tutorials"/>
      </div>

      <div v-if="tab_location == 'videos'">
        <videos :key="'videos'+tab_location" url="/api/navigator/toolbox/navigator-videos/" title="Videos"/>
      </div>

      <div v-if="tab_location == 'manuals'">
        <coming-soon/>
      </div>

    </div>
  </div>
  <!-- // END MAIN CONTENT - TOOLBOX -->
</template>
<script>
import Videos from "../components/toolbox/Videos";
import ComingSoon from "../components/ComingSoon";
import {mapState} from "vuex";
import Tabs from "../components/Tabs";


export default {
  name: 'Toolbox',
  components: {
    Tabs,
    Videos,
    ComingSoon
  },
  data() {
    return {
      tab_location: 'tutorials',
    }
  },
  computed: {
    ...mapState(['user_data']),
    tab_links() {
      let links = [];
      links = links.concat([
        {name: 'tutorials', label: this.$gettext('Tutorials')},
        {name: 'videos', label: this.$gettext('Videos')},
        {name: 'manuals', label: this.$gettext('User manuals')},
      ]);
      return links;
    }
  }
}
</script>
